import { ReactElement, useCallback, useState } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Badge, Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ProfileInfoDialog } from './ProfileInfoDialog';
import { UserConnection } from '../model/UserConnection';

type ConnectionItemProps = {
  actionElement: ReactElement;
  connection: UserConnection;
  connectionName?: ReactElement;
  connectionAvatar?: ReactElement;
  isHighlighted?: boolean;
};

const DefaultConnectionAvatar = (
  <AccountCircleIcon sx={{ width: 40, height: 40, mr: 5 }} />
);

export const ConnectionItem = ({
  actionElement,
  connectionAvatar = DefaultConnectionAvatar,
  connectionName,
  connection,
  isHighlighted = false,
}: ConnectionItemProps) => {
  const [openDialog, setOpenDialog] = useState(false);
  const showUserProfile = useCallback(async () => {
    setOpenDialog(true);
  }, []);
  return (
    <>
      <Box
        onClick={showUserProfile}
        sx={{
          width: 'calc(100% + 80px)',
          px: 10,
          py: 3,
          ml: -10,
          background: isHighlighted ? '#ffffff' : 'none',
          '&:hover': {
            background: '#ecf2fb',
          },
          cursor: 'pointer',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'center',
          }}
        >
          <Badge
            variant='dot'
            color='primary'
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            invisible={!isHighlighted}
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#00b2a9',
              },
            }}
          >
            {connectionAvatar}
          </Badge>
          {connectionName ? <Box sx={{ flex: 1 }}>{connectionName}</Box> : null}
          <Box sx={{ flex: 2 }}>
            <Typography>{formattedAddress(connection)}</Typography>
          </Box>
          <Box sx={{ ml: 8, mr: 6, width: 60 }}>
            <Typography>
              <FormattedMessage
                id='community.connections.kids'
                values={{ numOfKids: connection.numOfKids }}
              />
            </Typography>
          </Box>
          <Box sx={{ width: 350, textAlign: 'end' }}>{actionElement}</Box>
        </Box>
      </Box>
      {openDialog && (
        <ProfileInfoDialog
          openDialog={openDialog}
          onCloseDialog={() => setOpenDialog(false)}
          peerProfileGuid={connection.userProfileGuid}
          actionElement={actionElement}
        />
      )}
    </>
  );
};

export const formattedAddress = (addressInfo: {
  city: string;
  zipCode?: string;
  state: string;
}) =>
  [
    addressInfo.city,
    addressInfo.zipCode != null
      ? `${addressInfo.state} ${addressInfo.zipCode}`
      : addressInfo.state,
  ]
    .filter((elem) => elem)
    .join(', ');
